<template>
  <v-container pa-0 py-3 dark flat ref="fullSelectionContainer" v-resize="onResize">
      <v-layout v-if="!mobile" row wrap py-4 align-center class="inner-container" mx-auto>
        <v-flex md3 px-4 py-2 align-center>
          <v-layout row wrap py-0 justify-center align-center>
            <v-container pa-0 align-center justify-center class="text-center">
              <v-img :src='require("../../assets/static/img/webp/Ahorro.webp")' max-width="200px"></v-img>
            </v-container>
          </v-layout>
        </v-flex>
        <v-flex md3 px-4 py-2 align-center>
          <v-container pa-0 align-center justify-center class="text-center">
            <v-img :src='require("../../assets/static/img/webp/Ayudantes-portada2.webp")' max-width="200px"></v-img>
          </v-container>
        </v-flex>
        <v-flex md3 px-4 py-2 align-center>
          <v-container pa-0 align-center justify-center class="text-center">
            <v-img :src='require("../../assets/static/img/webp/personas.webp")' max-width="200px"></v-img>
          </v-container>
        </v-flex>
        <v-flex md3 px-4 py-2 align-center>
          <v-container pa-0 align-center justify-center class="text-center">
            <v-img :src='require("../../assets/static/img/webp/Seguridad2.webp")' max-width="200px"></v-img>
          </v-container>
        </v-flex>
      </v-layout>

      <div v-else>
        <v-layout py-4 align-center mx-auto>
          <v-flex md12 px-4 py-2 align-center>
            <v-layout  py-0 justify-center align-center>
              <v-container pa-0 row align-center justify-center class="text-center">
                <v-img :src='require("../../assets/static/img/webp/ahorro-mobile.webp")' max-width="350px"></v-img>
              </v-container>
              <v-container pa-0 align-center justify-center class="text-center">
                <v-img :src='require("../../assets/static/img/webp/ayudantes-mobile.webp")' max-width="350px"></v-img>
              </v-container>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout py-4 align-center mx-auto>
          <v-flex md12 px-4 py-2 align-center>
            <v-layout  py-0 justify-center align-center>
              <v-container pa-0 row align-center justify-center class="text-center">
                <v-img :src='require("../../assets/static/img/webp/personas-mobile.webp")' max-width="350px"></v-img>
              </v-container>
              <v-container pa-0 align-center justify-center class="text-center">
                <v-img :src='require("../../assets/static/img/webp/seguridad-mobile.webp")' max-width="350px"></v-img>
              </v-container>
            </v-layout>
          </v-flex>
        </v-layout>

      </div>
  </v-container>
</template>

<script>
  import { EventBus } from '../../events.js'
  import resize from 'vue-resize-directive'
  export default {
    name: 'HomeInfo',
    directives: {
      resize
    },
    data () {
      return {
        shake: false,
        windowWidth: 0,
        mobile: false
      }
    },
    mounted(){
      this.$nextTick(function() {
	      window.addEventListener('resize', this.getWindowWidth)
	      this.getWindowWidth()
	    })
      setTimeout(() => {
        this.shake = false
      }, 2000);
      
    },
    methods: {
      getWindowWidth(event) {
        this.windowWidth = document.documentElement.clientWidth
      	this.mobile = false
        if( this.windowWidth < 762 ){
        	this.mobile = true
        }
      },
      goTo(route){
        this.$router.push({name: route})
      },
      onResize(){-
        EventBus.$emit('selectionHeight', this.$refs.fullSelectionContainer.clientHeight)
      }
    }
  }
</script>

<style scoped>
  .text-center{text-align: center;}
  .background-duo{
    
  }
</style>